import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppState } from 'src/app/app.service';
import { HomeV5Service } from 'src/app/pages/home-v5/home-v5.service';
import { LibraryService } from '../library.service';
import { I18n } from 'src/app/i18n.service';
import { ToasterService } from 'src/app/toaster.service';
import { ModalController } from '@ionic/angular';
import { HomeUiService } from 'src/app/new-design/home-ui.service';
import { AnimationsService } from 'src/app/shared/animations.service';
import { DailyStepsContentWebModalV2Component } from 'src/app/new-design/daily-steps-content-web-modal-v2/daily-steps-content-web-modal-v2.component';
import { ReflectionService } from './reflection.service';

@Component({
  selector: 'app-full-screen-reflection',
  templateUrl: './full-screen-reflection.component.html',
  styleUrls: ['./full-screen-reflection.component.scss'],
})
export class FullScreenReflectionComponent implements OnInit {

  reflection: any
  journalPost: any
  isMobile: boolean
  currentPath: any
  stepNumber: number
  currentUser: any
  isonboardingcompleted: any;
  isBackAllowed: boolean
  chapterStepInfo;
  journalNote;
  isEditNote: boolean = false;
  constructor(private appState: AppState,
    public i18n: I18n,
    private route: Router,
    private modalController: ModalController,
    public toasterService: ToasterService,
    public reflectionService: ReflectionService,
    private homeUIService: HomeUiService,
    private homeService: HomeV5Service,
    private libraryService: LibraryService,
    private animationService: AnimationsService) {
    this.isMobile = this.appState.get('isMobile')
    this.journalPost = this.appState.get('journalPost')
    this.currentPath = this.appState.get('currentPath')
    this.currentUser = this.appState.get('currentUser')
    this.isBackAllowed = this.appState.get('isBackAllowed')
    console.log('journalPost :', this.journalPost);
    if (this.journalPost) {
      if (this.journalPost) {
        this.chapterStepInfo = this.currentPath.findChapterStepByScreenContentId(this.appState.get('DailyStepsData'), this.journalPost?.screen_content_id)
        this.stepNumber = this.chapterStepInfo?.stepPosition
      }
    }
    this.reflection = this.journalPost
    this.journalNote = this.appState.get(`reflectionNote+${this.reflection.id}`)??this.reflection.note;
  }

  ngOnInit() {}

  openInStep(){
    // this.appState.set('screenId', 'daily-content-screen-reflection')
    this.homeUIService.dismissAllModals().then(()=>{
      console.log("modal dismiss", this.modalController.getTop())
      // this.modalController.dismiss().then(()=>{

    
      if (this.journalPost.pathId === this.currentPath.id || !this.journalPost.pathId) {
        this.appState.set('currentScheduleDay', this.stepNumber);
        this.appState.set('reviewingStepIndex',this.chapterStepInfo?.stepIndex)
        if (this.isMobile) {
          setTimeout(()=>{
            this.route.navigate(['/content', this.stepNumber],{queryParams:{startFromScreen:'daily-content-screen-reflection' ,currentOpenedChapter: this.chapterStepInfo?.chapterIndex, currentOpenedStep: this.chapterStepInfo?.stepIndex }}) 
          },700)
        } else {
          this.homeUIService.closeAllModals(this.stepNumber, this.chapterStepInfo,'daily-content-screen-reflection')
        }
        this.appState.set('isRouteToLibrary', true) 
      }else{
        var data = {
          pathId: this.currentPath.id,
          userId: this.currentUser.id
        }
        this.appState.set('prevPathData', data)
        setTimeout(() => {
          this.changePath(this.journalPost.pathId, this.currentUser.id, this.stepNumber)
        }, 600);
      }
    });
    // })
  }

  
  changePath(pathId, userId, stepNumber) {
    const request = {
      'user_id': userId,
      'active_path_id': pathId
    }

    this.homeService.subpathchange(request, 'Library - Reflection').subscribe(
      (response) => {
        let data = response["data"];
      this.homeUIService.dismissAllModals().then(()=>{
        try {
          let isOnboardContentPresent = data.onboardingSurvey || data?.isIntroVideo;
          if (data?.isonboardingcompleted.constructor === Array && data?.isonboardingcompleted?.length > 0 && isOnboardContentPresent) {
            let value = data['isonboardingcompleted'][0];
            this.isonboardingcompleted = value["isonboardingcompleted"];
            if ((this.isonboardingcompleted === false || this.isonboardingcompleted === null) && isOnboardContentPresent) {
              setTimeout(()=>{
              this.route.navigate(["/onboarding"], { state: { onboardingSurvey: data.onboardingSurvey, isIntroVideo: data?.isIntroVideo } });                          
              },600);
            } else if (this.isonboardingcompleted === true) {
              if (this.isMobile) {
                 setTimeout(()=>{
              this.route.navigate(['/content', stepNumber])
              },600);
              }
              else {
                 setTimeout(()=>{
                   this.homeUIService.openDailyStepsComponent(DailyStepsContentWebModalV2Component,{currentDay: stepNumber},'web-daily-steps-custom-modal')
                 },1500);            
              }
             
            }
          } else if(data?.isonboardingcompleted.constructor === Array && data?.isonboardingcompleted.length===0 && isOnboardContentPresent){
            setTimeout(()=>{
              this.route.navigate(["/onboarding"], { state: { onboardingSurvey: data.onboardingSurvey, isIntroVideo: data?.isIntroVideo } });                          
            },600);
          } else {
            this.homeUIService.checkSubpathStatus();
            if (this.isMobile) {
               setTimeout(()=>{
            this.route.navigate(['/content', stepNumber])
            },600);
            }
            else {
                setTimeout(()=>{
                   this.homeUIService.openDailyStepsComponent(DailyStepsContentWebModalV2Component,{currentDay: stepNumber},'web-daily-steps-custom-modal')
                 },1500);
            }
           
          }
        } catch (error) {
          setTimeout(()=>{
          this.route.navigate(['/main']);
          },600);
        }
      });
        this.refresh()
      }, (error) => {
        console.log('error :', error);
      }
    )
  }

  refresh() {
    return new Promise(resolve => {
      this.appState.refreshMainComponent.emit()
      setTimeout(resolve, 0)
    })
  }

   editNote(){
    this.isEditNote = true
  }

  saveNote(){
    this.isEditNote = false
    //  const requestData = {
    //     step_id: this.reflection?.step_id,
    //     screen_id: this.reflection?.screen_id,
    //     screen_content_id: this.reflection?.screen_content_id,
    //     reflection_text: this.journalNote
    //   }

    // if (!this.journalNote) {
    //   this.toasterService.warning(this.i18n.t('Please enter a comment'))
    // } else {
    //   this.reflectionService.saveReflectionAnswerForKyper(requestData).subscribe(
    //     (response) => {
    //       this.toasterService.success(this.i18n.t("Note saved."))
    //     },
    //     (error) => {
    //       console.log('Error for feedback ', error)
    //     }
    //   )
    // }
    const requestData = {
      // id: this.journalPost.id,
      // text: this.journalNote
      screen_content_id: this.journalPost?.screen_content_id,
        step_id: this.journalPost?.step_id,
        note: this.journalNote,
        saved_type: 'reflection'
    }
    this.libraryService.save(requestData).subscribe(
      (response) => {
        this.appState.set(`reflectionNote+${this.reflection.id}`,this.journalNote)
        this.toasterService.success(this.i18n.t("Note saved."))
      },
      (error) => {
        console.log('Error for feedback ', error)
      }
    )
  }
  close(){
    if (this.isBackAllowed) {
      this.appState.set('isBackAllowed', undefined)
    }
    this.appState.set('dontRefresh', true)
   // window.history.back()
   this.modalController.dismiss();
  }

}
